export const StoryblokConfig = {
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN
};
